import React, { useEffect, useState } from "react";
import api, { apiError } from "../../api";
import { useLang } from "../../i18n";
import { useConfig } from "../../context/ConfigContext";
import { wsLabel } from "../../utils";
import LeaderboardPanel from "../../components/LeaderboardPanel";
import { SkeletonPanel } from "../../components/common";
import { toast } from "sonner";

const PERIODS = ["week", "month", "term", "all"];

export default function LeaderboardPage() {
  const { t, lang } = useLang();
  const { config } = useConfig();
  const [period, setPeriod] = useState("week");
  const [data, setData] = useState(null);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    setData(null);
    setHidden(false);
    api.get("/leaderboard", { params: { period, limit: 50 } })
      .then((r) => setData(r.data.entries))
      .catch((e) => {
        if (e.response?.status === 403) setHidden(true);
        else toast.error(apiError(e, t));
      });
  }, [period, t]);

  return (
    <div className="max-w-2xl mx-auto space-y-6" data-testid="leaderboard-page">
      <h2 className="text-2xl sm:text-3xl font-black text-center">{wsLabel(config?.ui_labels, "leaderboard", lang, t("lb.title"))}</h2>
      <div className="flex flex-wrap justify-center gap-2">
        {PERIODS.map((p) => (
          <button key={p} data-testid={`period-${p}`} onClick={() => setPeriod(p)}
            className={`px-5 py-2 rounded-full text-sm font-extrabold border transition-colors ${period === p ? "bg-gradient-to-r from-[#FFAE32] to-[#FFC83D] text-[#3A2400] border-transparent glow-gold" : "border-white/15 text-[#A5A0D6] hover:text-white"}`}>
            {t(`lb.${p}`)}
          </button>
        ))}
      </div>
      {hidden ? (
        <p className="text-center text-[#A5A0D6] font-bold py-16" data-testid="leaderboard-hidden">🔒</p>
      ) : !data ? (
        <SkeletonPanel lines={6} />
      ) : (
        <LeaderboardPanel entries={data} title={t(`lb.${period}`)} />
      )}
    </div>
  );
}
